import React from 'react'

import { ButtonClean, Heading } from '@fourthwall/components'

import * as S from './styled'

export const Header = () => (
  <div style={{ marginBottom: 32 }}>
    <Heading type="h3" weight="bold">
      Perks and tiers
    </Heading>
    <S.Subheading>
      Perks determine the benefits that members get by signing up for one of your paid tiers.{' '}
      <ButtonClean
        label="Learn more"
        appearance="secondary"
        href="https://help.fourthwall.com/hc/en-us/articles/13331327040539-Memberships-Quick-Start-Guide"
        target="_blank"
        withUnderline
      />
    </S.Subheading>
  </div>
)
